import sectionGatorzReviewsCss from '../css-snippets/section-gatorz-reviews';
import dividerPrimary from '../../../views/website/products/components/description/ui-modules/divider-primary/raw-html.js';
import accordionPrimary from '../../../views/website/products/components/description/ui-modules/accordion-primary/raw-html.js';

const dividerPrimaryHtml = dividerPrimary({
  show: true,
  maxWidth: 9999,
  height: 3,
  align: 'center',
  backgroundColor: '#C3C3C3',
});

const STAR_PATH =
  'M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z';

const overviewStarSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="${STAR_PATH}"></path></svg>`;

const closeIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>`;

const penIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen-icon lucide-square-pen"><path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"/></svg>`;

const overviewStars = Array(5)
  .fill(overviewStarSvg)
  .join('');

const rateListRows = [5, 4, 3, 2, 1]
  .map(rate => {
    const isTopRate = rate === 5;
    return `
              <tr class="rate-item" data-rate-value="${rate}">
                <td class="rate-value">
                  <div class="rate-value-stars" data-full-stars="${rate}">
                    ${overviewStars}
                  </div>
                </td>
                <td class="rate-bar">
                  <div class="rate-bar-bg">
                    <div class="rate-bar-fill" style="width: ${isTopRate ? '100%' : '0%'}"></div>
                  </div>
                </td>
                <td class="rate-count">${isTopRate ? '10' : '0'}</td>
              </tr>`;
  })
  .join('');

const accordionContentHtml = `
  <div class="accordion-collapsible-body container" data-attribute="accordion-collapsible-body">
    <div class="accordion-collapsible-body__inner">
      <div
        class="review-overview"
        data-attribute="review-overview"
        style="background-color: #ffffff"
      >
        <div class="review-overview-stats" data-attribute="review-overview-stats">
          <div class="review-stats" data-attribute="review-stats">
            <div class="rating-summary" data-attribute="rating-summary">
              <div
                class="rating-score-container"
                data-attribute="rating-score-container"
              >
                <div class="rating-score" data-attribute="rating-score">5</div>
                <div
                  class="wrap-stars"
                  data-full-stars="5"
                  data-attribute="wrap-stars"
                >
                  ${overviewStars}
                </div>
              </div>
              <div
                class="reviewers-count-container"
                data-attribute="reviewers-count-container"
              >
                Based on
                <span class="reviewers-count" data-attribute="reviewers-count"
                  >10</span
                >
                reviews
              </div>
            </div>
            <table class="rate-list" data-attribute="rate-list">
              <tbody>
                ${rateListRows}
              </tbody>
            </table>
          </div>
          <div
            class="customer-images-container"
            data-attribute="customer-images-container"
          >
            <button
              type="button"
              class="button-write-review"
              data-attribute="button-write-review"
            >
              ${penIconSvg} Write a review
            </button>
          </div>
        </div>
      </div>
      <div class="reviews-tabs" data-attribute="reviews-tabs">
        <div class="reviews-tab" data-attribute="reviews-tab">
          Reviews
          <span class="reviewers-count" data-attribute="reviewers-count">10</span>
        </div>
      </div>
      <div class="reviews-list">
        <div
          class="reviews-container swiper"
          data-attribute="reviews-container"
          data-col-per-view="4"
        >
          <div class="reviews-swiper-wrapper swiper-wrapper"></div>
        </div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
  </div>
`;

const accordionPrimaryHtml = accordionPrimary(accordionContentHtml, {
  open: true,
  title: '<h2><strong>REVIEWS</strong></h2>',
  backgroundColor: '#ffffff',
  color: '#000000',
  icon: {
    type: 'plus-minus',
    position: 'right',
    show: true,
  },
});

const html = `
<style>${sectionGatorzReviewsCss}</style>
<div
  class="product-reviews-wrapper product-reviews-wrapper-unique-id"
  data-id="unique-id"
  data-attribute="product-reviews-container"
  style="background-color: #ffffff"
  data-top-padding="false"
  data-bottom-padding="true"
>
  <div class="wrap-product-reviews">
    ${accordionPrimaryHtml} 
    ${dividerPrimaryHtml}
  </div>
</div>

<div
  onclick="window.closeImageModal()"
  class="modal-preview-image"
  style="display: none"
>
  <div onclick="event.stopPropagation()" class="modal-preview-image-content">
    <img loading="lazy" data-attribute="modal-preview-image" src="" alt="" />
    <button
      type="button"
      class="close-modal-preview-image"
      data-attribute="close-modal-preview-image"
      onclick="window.closeImageModal()"
    >
      ${closeIconSvg}
    </button>
  </div>
</div>
`;
export default html;
